import { INVALIDATE as AUTH_INVALIDATE } from '@/store/actions/auth';
import { SET_ERROR, CLEAR_ERROR } from '@/store/actions/error';

const initialState = {
    errors: [],
    location: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_ERROR: {
            const { data: error } = action;
            return { ...state, errors: [error].concat(state.errors) };
        }

        case CLEAR_ERROR: {
            const { id } = action.data;
            return {
                ...state,
                errors: state.errors.filter((error) => error.id !== id)
            };
        }

        case '@@router/LOCATION_CHANGE': {
            const prevLocation = state.location;
            const location = action.payload.pathname;

            return {
                errors:
                    prevLocation !== location
                        ? state.errors.filter((error) => error.persist === true)
                        : state.errors,
                location
            };
        }

        case AUTH_INVALIDATE:
        default: {
            return state;
        }
    }
};
